import React from 'react';
import { createRoot } from 'react-dom/client';
import CeePriceChart from './cee-price-chart';

import './table.css';

document.addEventListener('DOMContentLoaded', function () {
	const elements = document.querySelectorAll(
		'.gext-cee-price-chart-container'
	);
	elements.forEach((element) => {
		const dataElement = element.querySelector('.gext-cee-data');
		if (!dataElement) return;

		const data = JSON.parse(dataElement.textContent || '{}');
		const root = createRoot(element);
		root.render(<CeePriceChart data={data} />);
	});
});
